import { permissoes, routesNames } from '@/core/constants'
import GestaoDePedidoView from '@/views/pages/ata/acessar/gestao-de-pedido/GestaoDePedidoView.vue'

export default {
	name: routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW,
	path: 'gestao-do-pedido/',
	component: GestaoDePedidoView,
	meta: {
		page: {
			title: 'Ata de Registro de Preço',
			subtitle: 'Gestão do Pedido',
		},
		requiresAuth: true,
		authorities: [permissoes.ataVisualizar, permissoes.ataEditar], // alterar isso depois
	},
}
